import React, { useEffect, useState } from 'react'
import { Button, Drawer, Empty, Modal } from 'antd'
import { useAppParamsContext } from 'contexts/AppParamsContext'
import { useTranslation } from 'react-i18next'
import './index.scss'
import BidvCancelIcon from 'assets/icons/icon_ht_cancel.png'
import CustomerReviewDetailModel from './CustomerReviewDetailModel'
import NoDataAvailable from 'assets/icons/no_data_available.png'

export default function CustomerReviewList({ isOpen, onClose, stationsId, callBackBooking, apiFunction, fieldMapper, title, emptyText }) {
  const { appThemeName } = useAppParamsContext()

  const isBidvTheme =
    String(appThemeName || '').toUpperCase() === 'BIDV'
  const [list, setList] = useState([])
  const [totalNextPage, setTotalNextPage] = useState(0)
  const { t: translation } = useTranslation()
  const [filter, setFilter] = useState({
    limit: 10,
    skip: 0,
    filter: {
      stationsId: stationsId
    },
    order: {
      key: 'createdAt',
      value: 'desc'
    }
  })
  const getData = (payload) => {
    if (!stationsId) {
      return
    }
    apiFunction &&
      apiFunction(payload).then((result) => {
        if (result?.statusCode === 200) {
          setList(result?.data?.data || [])
          const data = result?.data?.data
          const newData = payload?.skip > 0 ? [...list, ...data] : data
          setList(newData)
          setTotalNextPage(result?.data?.total || 0)
          setFilter(payload)
        }
      })
  }

  useEffect(() => {
    const payload = {
      ...filter,
      filter: {
        ...filter.filter,
        stationsId: stationsId
      }
    }
    isOpen && getData(payload)
  }, [isOpen, stationsId])

  const popupContent = (
  <>
    <div
      className="mt-3 review-header sticky-header d-flex text-normal fw-bold ai-c j-sb"
      style={{
        backgroundColor: 'transparent',
        color: 'var(--title-color)',
        height: '25px'
      }}
    >
      <div className="d-flex ai-c mg-auto">
        <div className="title text-uppercase">{title}</div>
      </div>
    </div>

    <div className="CustomerReviewList-wrapper">
      {list.map((item, index) => (
        <div key={index} className="w-100">
          <CustomerReviewDetailModel {...fieldMapper(item)} />
        </div>
      ))}

      {totalNextPage > 0 && (
        <div
          className="CustomerReviewList-seeMore"
          onClick={() => {
            const newPayload = {
              ...filter,
              skip: filter?.skip + filter.limit
            }

            getData(newPayload)
          }}
        >
          {translation('See_more')}
        </div>
      )}

      {list.length === 0 && (
        <div
          className={`CustomerReviewList-empty ${
            isBidvTheme ? 'CustomerReviewList-empty-bidv' : ''
          }`}>
          {isBidvTheme ? (
            <Empty
              image={NoDataAvailable}
              imageStyle={{
                width: 160,
                height: 160
              }}
              description={emptyText}
            />
          ) : (
            <Empty description={emptyText} />
          )}
        </div>
      )}
    </div>
  </>
)

  return isBidvTheme ? (
    <Drawer
      title={title}
      placement="bottom"
      open={isOpen}
      onClose={onClose}
      closable
      closeIcon={
        <img
          src={BidvCancelIcon}
          className="bidv-bottom-sheet-close-icon"
          alt="Đóng"
        />
      }
      destroyOnClose
      height="auto"
      className="bidv-station-bottom-sheet">
      {popupContent}
    </Drawer>
  ) : (
    <Modal
      onCancel={onClose}
      centered
      width={600}
      footer={null}
      open={isOpen}>
      {popupContent}
    </Modal>
  )
}
